import {useEffect, useState} from "react";
import {getClientsInfo} from "../../services/Administrative/clientsService";
import {TicketFilters} from "../../services/SalesRep/salesrepTicketsService";
import {Bounce, toast} from "react-toastify";

interface UseGetClientsProps {
    filters?: TicketFilters;
}

const stateOptions = [
    {value: 'ACTIVE', label: 'Activo'},
    {value: 'DISABLED', label: 'Deshabilitado'},
    {value: 'BLOCKED', label: 'Bloqueado'}
];


export const useGetClients = ({ filters = {} }: UseGetClientsProps) => {
    const [clients, setClients] = useState<any>([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const addClientLocally = (newClient: any) => {
        const transformedClient = {
            NOMBRE: newClient.name,
            CLAVE: newClient.uniqueCode,
            ESTADO: stateOptions.find(option => option.value === newClient.clientState)?.label || "",
            ID: newClient.id
        }

        setClients((prevClients:any) => [...prevClients, transformedClient]);
    };

    useEffect(() => {
        const fetchClients = async () => {
            try {
                setIsLoading(true);
                const response:any = await getClientsInfo(page, filters);
                setClients(response.clients);
                setPage(response.page);
                setTotalPages(response.totalPages);
            } catch (error:any) {
                if (error.response) {
                    if (error.response.status === 404) {
                        toast.warning(
                            `${error.response.data.message}. Por favor, verifique o limpie los filtros`,
                            {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                                theme: 'colored',
                                transition: Bounce,
                            }
                        );
                    } else {
                        toast.error("Error al obtener los clientes.", {
                            position: 'top-right',
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                            theme: 'colored',
                            transition: Bounce,
                        });
                    }
                } else {
                    toast.error("Error al obtener los clientes.", {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: 'colored',
                        transition: Bounce,
                    });
                }
            }
            finally {
                setTimeout(() => {setIsLoading(false)}, 600)
            }
        };
        fetchClients();
    }, [page, filters]);

    return { clients, totalPages , isLoading, page, setPage, addClientLocally};
};
